import { Button, Empty, Flex, Spin } from 'antd';
import TemplateCard from '../../../components/templateCardNew';
import Page from '../../../components/page';
import ActionHeader from '../../../components/actionHeader';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  fetchTemplates,
  selectIsFetchingTemplates,
  selectTemplates,
} from '../../../slices/templates';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../store';
import { useNavigate } from 'react-router';
import { deleteTemplates } from '../../../utils/httpRequest';

const TemplateList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [search, setSearch] = useState<string>();
  const templates = useSelector(selectTemplates);
  const isFetchingTemplates = useSelector(selectIsFetchingTemplates);

  const handleAddClick = () => {
    navigate('add');
  };

  const handleSearch = (searchText?: string) => {
    setSearch(searchText);
    if (!isFetchingTemplates) {
      dispatch(
        fetchTemplates({
          search: searchText,
        })
      );
    }
  };

  const handleDelete = async (id: string) => {
    await deleteTemplates(id);
    dispatch(fetchTemplates({ search }));
  };

  useEffect(() => {
    dispatch(fetchTemplates({ search }));
  }, []);

  return (
    <Page
      header={
        <ActionHeader
          title={t('template')}
          titleTag={`(${templates.length})`}
          showSearch
          onSearch={handleSearch}
          endSlot={
            <Button type="primary" onClick={handleAddClick}>
              {t('template_add_new')}
            </Button>
          }
        />
      }
    >
      {isFetchingTemplates ? (
        <Spin size="large" style={{ marginTop: 100 }} />
      ) : (
        <Flex vertical gap={8} style={{ padding: '0 24px' }}>
          {templates.length ? (
            templates.map((item) => (
              <TemplateCard
                key={item.templateID}
                data={item}
                onEdit={() => {
                  navigate(`${item.templateID}/edit`);
                }}
                onClick={() => {
                  navigate(`${item.templateID}`);
                }}
                onDelete={() => handleDelete(item.templateID)}
              />
            ))
          ) : (
            <Empty style={{ paddingTop: 80 }} />
          )}
        </Flex>
      )}
    </Page>
  );
};

export default TemplateList;
